import { useTranslation } from 'react-i18next';
import { Button, Container, Icon, RubricTable, Stack, styled, Text } from 'shell/components';

const Desktop = ({ rubric, onClickBack, onClickEdit, onClickDownloadCSV, onClickDelete }) => {
    const { t } = useTranslation('assignment');
    return (
        <Container device={'desktop'}>
            <RootStack spacing={5}>
                <Stack spacing={3}>
                    <CustomButton startIcon={<Icon kind={'arrowLeft'} />} variant={'borderless'} onClick={onClickBack}>
                        {t('common:controls.back', 'Back')}
                    </CustomButton>
                    <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                        <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                            {rubric.rubric.title}
                        </Text>
                        <Stack sx={{ flexShrink: 0 }} direction={'row'} spacing={4}>
                            <Button
                                startIcon={<Icon kind={'edit'} />}
                                variant={'tertiary'}
                                onClick={() => onClickEdit(rubric)}
                            >
                                {t('common:controls.edit', 'Edit')}
                            </Button>
                            <Button
                                color={'neutral'}
                                startIcon={<Icon kind={'download'} />}
                                variant={'tertiary'}
                                onClick={() => onClickDownloadCSV(rubric)}
                            >
                                {t('common:controls.download-csv', 'Download CSV')}
                            </Button>
                            <Button
                                color={'destructive'}
                                startIcon={<Icon kind={'delete'} />}
                                variant={'tertiary'}
                                onClick={() => onClickDelete(rubric)}
                            >
                                {t('common:controls.delete', 'Delete')}
                            </Button>
                        </Stack>
                    </Stack>
                </Stack>
                <RubricTable isExpanded type={'view'} data={rubric.rubric.criteria} />
            </RootStack>
        </Container>
    );
};

const RootStack = styled(Stack)(({ theme }) => {
    return {
        width: '100%',
        paddingBottom: theme.spacing(5),
    };
});

const CustomButton = styled(Button)(() => {
    return {
        alignSelf: 'flex-start',
    };
});

export default Desktop;
